<template>
    <div id="main1">
        <!--<link rel="stylesheet" href="/themes/ito/css/dashboard.css">-->
        <!--<link rel="stylesheet" href="/themes/ito/css/unit-detail.css?v=1">-->
        <link rel="stylesheet" href="/themes/web/assets/css/percentage-circle.css?v=3">
        <link rel="stylesheet" href="/themes/web/assets/css/unit-detail.css?v=4">
        <div class="container">
            <template v-if="isLoading == true">
                <content-placeholders :rounded="true">
                    <content-placeholders-img/>
                    <content-placeholders-heading/>
                </content-placeholders>
            </template>
            <template v-else>
                <h2 v-if="units.length == 0"></h2>
                <div v-if="units.length != 0">
                    <div id="page-header-fixed">
                        <div class="">
                            <div id="page-header">
                                <ul class="breadcrumb">
                                    <li class="icon">
                                        <a @click="$router.push({ name: 'home' })">
                                            <img src="/themes/web/assets/images/back-to.svg" alt="">
                                        </a>
                                    </li>
                                    <li class="active">{{ units.name }}: {{units.title}}</li>
                                </ul>
                                <div class="buttons">
                                    <div class="btn-group">
                                        <button type="button"
                                                v-bind:class="tab=='overview'?'active btn btn-default':'btn btn-default'"
                                                @click="changeTab('overview')">{{$t('overview')}}
                                        </button>
                                        <!-- <button type="button"
                                                v-bind:class="tab=='discuss'?'active btn btn-default':'btn btn-default'"
                                                @click="changeTab('discuss')"  v-if="user_info.account_type != 1">{{$t('discussion')}}
                                        </button> -->
                                        <button type="button"
                                                v-bind:class="tab=='report'?'active btn btn-default':'btn btn-default'"
                                                @click="changeTab('report')">{{$t('report')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tab == 'overview'">
                        <div id="unit-detail-info">
                            <!--<h4 class="title">{{ units.title }}</h4>-->

                            <div class="info" style="position: relative">
                                <!-- <div class="button-more" @click="changeDetail()">{{isDetail ? '+': '-'}}</div> -->
                                <div class="info-thumb" v-show="isDetail">
                                    <div class="thumb r16x9">
                                        <div class="thumb-content">
                                            <img class="thumb-img" :src="units.image" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="info-content">
                                    <h4 class="title">{{ units.title }}</h4>
                                    <div class="desc-1" v-if="showText" v-show="isDetail">
                                      {{ units.desc.slice(0, 299) }} ......
                                    </div>
                                    <div class="desc-1" v-else v-show="isDetail">
                                      {{ units.desc }}
                                    </div>
                                    <!--<ul>-->
                                    <!--<li><i class="ito-icon-science"></i> {{$t('class_science')}}</li>-->
                                    <!--<li><i class="ito-icon-grade"></i> {{$t('grade')}}</li>-->
                                    <!--<li><i class="ito-icon-english"></i> {{$t('english')}}</li>-->
                                    <!--<li><i class="ito-icon-lesson"></i> {{ units.total }} {{$t('lesson')}}</li>-->
                                    <!--</ul>-->
                           

                                    <div class="d-flex justify-content-between align-items-center" v-if="this.user_info.account_type!=1">
                                        <div class="d-flex align-items-center" >
                                          <a href="javascript:;" v-if="units.external_link"   @click="openExternal" class="ebook-link" style="margin-right: 5px;text-decoration: none; font-weight: 600; background: #FF7800">
<!--                                            <img src="/themes/web/assets/images/lesson/external.svg"/>-->
                                             <span>{{$t(units.external_title)}}</span>
                                          </a>

                                            <router-link @click.native="handleGACustomEvent('IP2_W_2000', units.id)"
                                            v-if="true"  :to="{ path: '/ebook/' + units.id }" target="_blank" class="ebook-link" style="text-decoration: none; font-weight: 600;">
                                                <img src="/themes/web/assets/images/lesson/ebook1.svg"> 
                                                <span style="margin-left: 5px">{{$t('ebook_digital')}}</span>
                                                <span v-if="units.ebook_page_range" style="margin-left: 8px; font-size: 12px;"></span>
                                            </router-link>
                                            <div style="color: #000; height: 32px; margin-top: 12px; display: flex; align-items: center; margin-left: 8px; font-size: 13px;">(page {{rebuildEbookPage(units.ebook_page_range)}})</div>
                                            <!-- <router-link v-if="true" :to="{path: '/ebook/'+units.id}" target="_blank" class="ebook-link" style="text-decoration: none; font-weight: 600; color: #11A9FF"></router-link> -->
                                        </div>
                                        <div class="tools" style="margin-top:20px; cursor: pointer;">
                                            <p v-if="units.desc.length > 299" @click="showText=!showText" class="view-more">{{showText ? $t('view_more') : $t('view_less')}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="unit-detail" class="card card-daily-challenge">
                            <div class="card-header" style="display: flex;justify-content: space-between;">
                                <div class="card-title">{{$t('lesson')}}</div>
                                <div class="tools">
                                    <nav class="ito-tabs">
                                        <a :class="type == 1?'active':''" @click="changeType(1)" style="cursor: pointer">{{$t('lessons')}}</a>
                                        <!-- <a :class="type == 2?'active':''" @click="units.extentions ? changeType(2): changeType(1)" style="cursor: pointer">{{$t('extension')}} <img v-show="!units.extentions" src="https://alpha-v3.ismart.edu.vn/themes/ito/images/icons/icon-lock-sidebar.svg"></a> -->
                                        <a :class="type == 2?'active':''" @click="changeType(2)" style="cursor: pointer">{{$t('extension')}}</a>
                                    </nav>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="card-content" v-if="type==1">
                                    <div class="row">
                                        <div class="col-md-4" v-for="(lesson, index) in units.lessons" v-bind:key="index">
                                            <div v-if="lesson.status == 0">
                                                <router-link
                                                        :to="{path: '/lesson/'+subject_id+'-'+units.id+'-'+lesson.id}">
                                                    <div class="lesson-item">
                                                        <div class="lesson-item-body">
                                                            <h4 class="title">{{ lesson.name }}</h4>
                                                            <div class="desc">{{ lesson.title }}</div>
                                                        </div>
                                                        <!-- <div class="lesson-item-bottom">
                                                            <div class="progress">
                                                                <div class="progress-load"
                                                                    v-bind:style="{ width: calcPercent(lesson.process,lesson.total) + '%' }"></div>

                                                                <span>{{ calcPercent(lesson.process, lesson.total) }}%</span>
                                                            </div>
                                                            <div class="success">
                                                                <i :class="calcPercent(lesson.process,lesson.total) == 100? 'lisa-icon-checked':'lisa-icon-checked-disable'"></i>
                                                            </div>
                                                        </div> -->
                                                        <div class="lesson-item-bottom" v-bind:class="lesson.process == lesson.total && lesson.total != 0? 'complete': ''">
                                                            <div class="flex">
                                                                <template v-for="(item, i) in lesson.items">
                                                                    <i style="margin-right:5px" class="lisa-icon-checked" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && lesson.process != lesson.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-1" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && lesson.process == lesson.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-disable" :title = "item.name" v-if="item.complete == 0 && item.type != 'handouts' && lesson.process != lesson.total"></i>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                {{$t('lisa_web_completeof', {process: lesson.process, total: lesson.total})}}
                                                                <!-- {{ $t('complete') }} {{ lesson.process }}  {{$t('of') }} {{ lesson.total }} -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </router-link>
                                            </div>
                                            <div v-if="lesson.status == 1 && lesson.upgrade_package != 0">
                                                <div>
                                                    <div class="lesson-item lock-unit" style="overflow: hidden;"
                                                        @click="(user_info.student_type != 2) ? upgradeAccountUnitTest(lesson.package_name) : ''">
                                                        <img class="lock-image" src="/themes/ito/images/icons/icon-lock-new.svg"/>
                                                        <div class="lesson-item-body">
                                                            <h4 class="title" style="color: rgb(170, 171, 183);font-size: 14px;line-height: 19px;">{{ lesson.name }}</h4>
                                                            <div class="desc">{{ lesson.title }}</div>
                                                        </div>
                                                        <div class="lesson-item-bottom" v-bind:class="lesson.process == lesson.total && lesson.total != 0? 'complete': ''">
                                                            <div class="flex">
                                                                <template v-for="(item, i) in lesson.items">
                                                                    <i style="margin-right:5px" class="lisa-icon-checked" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && lesson.process != lesson.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-1" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && lesson.process == lesson.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-disable" :title = "item.name" v-if="item.complete == 0 && item.type != 'handouts' && lesson.process != lesson.total"></i>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                {{$t('lisa_web_completeof', {process: lesson.process, total: lesson.total})}}
                                                                <!-- {{ $t('complete') }} {{ lesson.process }}  {{$t('of') }} {{ lesson.total }} -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-content" v-if="type==2">
                                    <div class="row">
                                        <div class="col-md-4" v-for="(extension, index) in units.extentions" v-bind:key="index">
                                            <div v-if="extension.status == 0">
                                                <router-link
                                                        :to="{path: '/extension-item/'+subject_id+'-'+units.id+'-'+extension.id}">
                                                    <div class="lesson-item">
                                                        <div class="lesson-item-body">
                                                            <h4 class="title">{{ extension.name }}</h4>
                                                            <div class="desc">{{ extension.title }}</div>
                                                        </div>
                                                        <!-- <div class="lesson-item-bottom">
                                                            <div class="progress">
                                                                <div class="progress-load"
                                                                    v-bind:style="{ width: calcPercent(extension.process,extension.total) + '%' }"></div>

                                                                <span>{{ calcPercent(extension.process, extension.total) }}%</span>
                                                            </div>
                                                            <div class="success">
                                                                <i :class="calcPercent(extension.process,extension.total) == 100? 'ito-icon-checked':'ito-icon-checked-disable'"></i>
                                                            </div>
                                                        </div> -->
                                                        <div class="lesson-item-bottom" v-bind:class="extension.process == extension.total && extension.total != 0? 'complete': ''">
                                                            <div class="flex">
                                                                <template v-for="(item, i) in extension.items">
                                                                    <i style="margin-right:5px" class="lisa-icon-checked" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && extension.process != extension.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-1" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && extension.process == extension.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-disable" :title = "item.name" v-if="item.complete == 0 && item.type != 'handouts' && extension.process != extension.total"></i>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                {{$t('lisa_web_completeof', {process: extension.process, total: extension.total})}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </router-link>
                                            </div>
                                            <div v-if="extension.status == 1 && extension.upgrade_package != 0">
                                                <div>
                                                    <div class="lesson-item lock-unit" style="overflow: hidden;"
                                                        @click="(user_info.student_type != 2) ? upgradeAccountUnitTest(extension.package_name) : ''">
                                                        <img class="lock-image" src="/themes/ito/images/icons/icon-lock-new.svg"/>
                                                        <div class="lesson-item-body">
                                                            <h4 class="title" style="color: rgb(170, 171, 183);font-size: 14px;line-height: 19px;">{{ extension.name }}</h4>
                                                            <div class="desc">{{ extension.title }}</div>
                                                        </div>
                                                        <!-- <div class="lesson-item-bottom">
                                                            <div class="progress">
                                                                <div class="progress-load"
                                                                    v-bind:style="{ width: calcPercent(extension.process,extension.total) + '%' }"></div>

                                                                <span>{{ calcPercent(extension.process, extension.total) }}%</span>
                                                            </div>
                                                            <div class="success">
                                                                <i :class="calcPercent(extension.process,extension.total) == 100? 'ito-icon-checked':'ito-icon-checked-disable'"></i>
                                                            </div>
                                                        </div> -->
                                                        <div class="lesson-item-bottom" v-bind:class="extension.process == extension.total && extension.total != 0? 'complete': ''">
                                                            <div class="flex">
                                                                <template v-for="(item, i) in extension.items">
                                                                    <i style="margin-right:5px" class="lisa-icon-checked" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && extension.process != extension.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-1" :title = "item.name" v-if="item.complete == 1 && item.type != 'handouts' && extension.process == extension.total"></i>
                                                                    <i style="margin-right:5px" class="lisa-icon-checked-disable" :title = "item.name" v-if="item.complete == 0 && item.type != 'handouts' && extension.process != extension.total"></i>
                                                                </template>
                                                            </div>
                                                            <div>
                                                                {{$t('lisa_web_completeof', {process: extension.process, total: extension.total})}}
                                                                <!-- {{ $t('complete') }} {{ lesson.process }}  {{$t('of') }} {{ lesson.total }} -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="tab == 'discuss' && user_info.account_type != 1">
                        <div class="modal" id="deleteConfirm" tabindex="-1" role="dialog"
                             aria-labelledby="deleteConfirm"
                             aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document"
                                 style="max-width: 330px;">
                                <div class="modal-content box-shadow-main paymment-status">
                                    <div class="close-popup" data-bs-dismiss="modal"></div>
                                    <h3 class="popup-title success">{{$t('lisa_web_completed_practice')}}</h3>
                                    <p class="mt-20 mb-20 txt-pop">{{$t('confirm_delete_comment_text')}}</p>
                                    <div class="form-group d-flex justify-content-between">
                                        <div class="lisa-btn-small" data-bs-dismiss="modal">{{$t('no')}}</div>
                                        <div class="lisa-btn-small active" data-bs-dismiss="modal" @click="deleteComment">
                                            {{$t('yes')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal" id="deleteConfirmCommenter" tabindex="-1" role="dialog"
                             aria-labelledby="deleteConfirmCommenter"
                             aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document"
                                 style="max-width: 330px;">
                                <div class="modal-content box-shadow-main paymment-status">
                                    <div class="close-popup" data-bs-dismiss="modal"></div>
                                    <h3 class="popup-title success">{{$t('lisa_web_completed_practice')}}</h3>
                                    <p class="mt-20 mb-20 txt-pop">{{$t('confirm_delete_comment_text')}}</p>
                                    <div class="form-group d-flex justify-content-between">
                                        <div class="lisa-btn-small" data-bs-dismiss="modal">{{$t('no')}}</div>
                                        <div class="lisa-btn-small active" data-bs-dismiss="modal" @click="deleteCommentCommenter">
                                            {{$t('yes')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="inputComment" tabindex="-1" role="dialog"
                             aria-labelledby="inputComment"
                             aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document"
                                 style="max-width: 550px;">
                                <div class="modal-content box-shadow-main paymment-status">

                                    <div class="form">
                                        <div class="reply-to">{{$t('replies_to')}} {{curUserReply}} :</div>
                                        <input id="trung" v-on:keydown.enter="replyComment" type="text"
                                               :placeholder="$t('lisa_web_write_comment')" v-model="currContent"/>
                                        <button v-bind:disabled="currContent===''" v-if="inputType == 'REPLY'"
                                                class="btn btn-default"
                                                @click="replyComment">{{$t('send')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="editConfirm" tabindex="-1" role="dialog"
                             aria-labelledby="editConfirm"
                             aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document"
                                 style="max-width: 550px;">
                                <div class="modal-content-edit  box-shadow-main-edit paymment-status">

                                    <div class="form">
                                        <input v-on:keyup.enter="editComment" type="text" :placeholder="$t('lisa_web_write_comment')"
                                               v-model="currContent"/>
                                        <button type="submit" v-bind:disabled="currContent===''"
                                                v-if="inputType == 'EDIT'" class="btn btn-default" @click="editComment">
                                            {{$t('send')}}
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="editConfirmCommenter" tabindex="-1" role="dialog"
                             aria-labelledby="editConfirmCommenter"
                             aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document"
                                 style="max-width: 550px;">
                                <div class="modal-content-edit  box-shadow-main-edit paymment-status">

                                    <div class="form">
                                        <input v-on:keyup.enter="editCommentCommenter" type="text" :placeholder="$t('lisa_web_write_comment')"
                                               v-model="currContent"/>
                                        <button type="submit" v-bind:disabled="currContent===''"
                                                v-if="inputType == 'EDIT'" class="btn btn-default" @click="editCommentCommenter">
                                            {{$t('send')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card card-comments" style="height: calc(100vh - 270px); margin-top: 0;">
                            <div @click="resetEdit" v-show="showTest" class="test-1"></div>
                            <div class="card-header">
                                <div  v-if="total_comment>1" class="card-title">{{$t('there_are')}} <b>{{total_comment}}</b> {{$t('comments')}}</div>
                                <div v-else class="card-title">{{$t('there_are')}} <b>{{total_comment}}</b> {{$t('comment')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="card-content" style="max-height: unset;">
                                    <div v-if="discuss.length != 0">
                                        <div class="nano" style="height: calc(100vh - 425px);">
                                            <div class="nano-content">
                                                <template>
                                                    <div v-for="(dc, index) in discuss" v-bind:key="index">
                                                        <div class="comment-item">
                                                            <div class="comment-item-avatar">
                                                                <div class="thumb">
                                                                    <div class="thumb-content">
                                                                        <!--<img :src="dc.avatar" alt="">-->
                                                                        <img :src="dc.avatar ? dc.avatar : '/themes/web/assets/images/avatar-default-2.svg'" alt="">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="comment-item-info">
                                                                <div class="header">
                                                                    <div class="title">{{dc.fullname}}</div>
                                                                    <div class="time">{{timeConverter(dc.time)}}
                                                                        <div @click="replyCommentConfirm(dc)"

                                                                            style="margin-left: 5px">
                                                                            <a v-if="dc.can_edit!=1" class="reply-comment">
                                                                                <img src="/themes/web/assets/images/discuss/note-2.svg"/>
                                                                            </a>


                                                                        </div>

                                                                        <div v-if="dc.can_edit==1"
                                                                            style="position: relative;margin-left: 5px"
                                                                            class="edit-cmt" v-on:click="showEdit(index)"
                                                                            :class="(editItem === index)? 'active': ''">
                                                                            <a class="edit-comment">
                                                                                <img src="/themes/web/assets/images/discuss/edit-2.svg"/>
                                                                            </a>
                                                                            <div class="box-edit" @focusout="resetEdit">
                                                                                <button class="edit-li"
                                                                                        @click="editCommentConfirm(dc.id,dc.content)">
                                                                                    <img src="/themes/web/assets/images/discuss/edit.svg" style="width: 22px;height: 22px;"/>

                                                                                    {{$t('btn_edit_comment')}}
                                                                                </button>
                                                                                <button class="reply-li"
                                                                                        @click="replyCommentConfirm(dc)">
                                                                                    <img src="/themes/web/assets/images/discuss/reply.svg" style="width: 22px;height: 22px;"/>
                                                                                    {{$t('btn_reply_comment')}}
                                                                                </button>
                                                                                <button class="delete-li"
                                                                                        @click="deleteConfirm(dc.id)">
                                                                                    <img width="18" height="18" style="width: 20px;height: 20px;margin-top: -3px;"
                                                                                        src="/themes/web/assets/images/discuss/delete.svg"/>
                                                                                        {{$t('btn_delete_comment')}}
                                                                                        
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="desc">
                                                                    {{dc.content}}
                                                                    <!--<div class="form">-->
                                                                    <!--<input type="text" placeholder="Write your comment" v-model="content"/>-->

                                                                    <!--<button class="btn btn-default" @click="sendComment">Send</button>-->
                                                                    <!--</div>-->
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-if="dc.commenter">
                                                            <div class="replies" v-if="dc.show_reply!=1">
                                                                <img class="replies-img"
                                                                    src="/themes/web/assets/images/discuss/curved-arrow.svg"/>
                                                                <button class="button-replies" @click="showReply(dc)">
                                                                    {{dc.commenter.length}} {{$t('replies')}}
                                                                </button>

                                                            </div>
                                                            <!--                                                <transition name="bounce">-->
                                                            <div class="card-content-commenter" v-if="dc.show_reply==1">

                                                                <div class="commenter comment-replies"
                                                                    v-for="(commenter, index1) in dc.commenter" v-bind:key="index1">
                                                                    <div class="comment-item comment-item-reply" v-if="dc.commenter">
                                                                        <div class="comment-item-avatar">
                                                                            <div class="thumb">
                                                                                <div class="thumb-content">
                                                                                    <img :src="commenter.avatar ? commenter.avatar : '/themes/web/assets/images/avatar-default-2.svg'" alt="">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="comment-item-info">
                                                                            <div class="header">
                                                                                <div class="title">{{commenter.fullname}}</div>
                                                                                <div class="time">
                                                                                    {{timeConverter(commenter.time)}}

                                                                                    <div v-if="commenter.can_edit==1"
                                                                                        style="position: relative;margin-left: 5px"
                                                                                        class="edit-cmt"
                                                                                        v-on:click="showEdit((index+1)*(discuss.length) +index1)"
                                                                                        :class="(editItem === ((index+1)*(discuss.length) +index1))? 'active': ''">
                                                                                        <a class="edit-comment">
                                                                                            <img src="/themes/web/assets/images/discuss/edit-2.svg"/>
                                                                                        </a>
                                                                                        <div class="box-edit"
                                                                                            @focusout="resetEdit">
                                                                                            <div class="button-edit">
                                                                                                <button class="edit-li"
                                                                                                        @click="editCommentConfirm(commenter.id,commenter.content)">
                                                                                                    <img src="/themes/web/assets/images/discuss/edit.svg"/>
                                                                                                    {{$t('btn_edit_comment')}}
                                                                                                </button>
                                                                                                <button class="delete-li"
                                                                                                        @click="deleteConfirmCommenter(commenter)">

                                                                                                    <img width="18" height="18"
                                                                                                        src="/themes/web/assets/images/discuss/delete.svg"/>
                                                                                                        {{$t('btn_delete_comment')}}
                                                                                                </button>
                                                                                            </div>

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="desc">
                                                                                {{commenter.content}}
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>
                                                                <img @click="showReply(dc)" class="replies-img-1"
                                                                    src="/themes/web/assets/images/discuss/curved-arrow.svg"/>
                                                                <div class="card-bottom-commenter">

                                                                    <div class="form">
                                                                        <input v-on:keyup.enter="replyComment_commenter(dc)"
                                                                            type="text" :placeholder="$t('lisa_web_write_comment')"
                                                                            v-model="dc.reply_content"/>
                                                                        <button v-bind:disabled="dc.reply_content===''"
                                                                                class="btn btn-default "
                                                                                @click="replyComment_commenter(dc)">{{$t('send')}}
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <!--                                                </transition>-->

                                                        </div>
                                                    </div>
                                                </template>                                                
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div class="discuss-empty-message" v-else>
                                        {{$t('there_is_no_comment')}}
                                    </div>

                                </div>

                                <div class="card-bottom">
                                    <div class="title-rep" v-if="commentType == 'EDIT'">{{$t('btn_edit_comment')}}<a class="reset-commenter" @click="resetDiscuss">{{$t('cancel')}}</a></div>
                                    <div class="title-rep" v-if="commentType == 'REPLY'">{{$t('replies_to')}} {{curUserReply}} <a class="reset-commenter" @click="resetDiscuss">{{$t('cancel')}}</a></div>
                                    <div class="form">
                                        <template v-if="commentType == 'NORMAL'">
                                            <input v-on:keyup.enter="sendComment" type="text"
                                                   :placeholder="[[$t('lisa_web_write_comment')]]" v-model="content"/>

                                            <button v-bind:disabled="content===''" class="btn btn-default"
                                                    @click="sendComment">{{$t('send')}}
                                            </button>
                                        </template>

                                        <template v-if="commentType == 'EDIT'">
                                            <input v-on:keyup.enter="editComment" type="text" :placeholder="$t('lisa_web_write_comment')"
                                                   v-model="currContent"/>
                                            <button type="submit" v-bind:disabled="currContent===''"
                                                    v-if="inputType == 'EDIT'" class="btn btn-default" @click="editComment">
                                                {{$t('send')}}
                                            </button>
                                        </template>
                                        <template v-if="commentType == 'REPLY'">
                                            <input v-on:keydown.enter="replyComment" type="text"
                                                   :placeholder="$t('lisa_web_write_comment')" v-model="currContent"/>
                                            <button v-bind:disabled="currContent===''" v-if="inputType == 'REPLY'"
                                                    class="btn btn-default"
                                                    @click="replyComment">{{$t('send')}}
                                            </button>
                                        </template>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div v-if="tab == 'report'">
                        <div id="rp" class="card card-reports">
                            <div class="card-body">
                                <div v-if="reports.length != 0">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <template>
                                                <div v-for="(lesson, index) in reports.lessons" v-bind:key="index">
                                                    <div class="lesson-report-container">
                                                        <div class="lesson-item-lv report-items"
                                                            v-on:click="itemTrigger(index)"
                                                            v-bind:class="{'active': (currentItem === index)}">
                                                            <h4 class="title" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ lesson.name }}</h4>
                                                            <div class="desc">{{ lesson.title }}</div>
                                                            <div class="success">
                                                                <i :class="calcPercent(lesson.process,lesson.total) == 100? 'lisa-icon-checked':''"></i>
                                                            </div>
                                                            <div v-bind:class="'c100'+' p'+mathRound(calcPercent(lesson.process,lesson.total))+ ' blue'">
                                                                <span>{{ calcPercent(lesson.process, lesson.total) }}%</span>
                                                                <div class="slice">
                                                                    <div class="bar"></div>
                                                                    <div class="fill"></div>
                                                                </div>
                                                            </div>
                                                            <div class="icon-expand-right">
                                                                <img src="/themes/ito/images/icons/expand_right.svg">
                                                            </div>
                                                        </div>
                                                        <div class="report-item-childs">
                                                            <div class="report-child-items item-detail" v-for="(practice, i) in lesson.items" v-bind:key="i">
                                                                <div class="report-attemps">
                                                                    <div class="report-item-head" v-on:click="attempTrigger(i)"
                                                                        v-bind:class="{'active': (currentAttemp === i)}">
                                                                        <div class="report-item-title">{{$t('practice')}} {{i+1}} :
                                                                            {{practice.name}}
                                                                        </div>
                                                                        <div class="report-item-head-right">
                                                                            <div>
                                                                                <div class="rating-crown">
                                                                                    <img src="/themes/ito/images/icon-crown.svg"
                                                                                        v-for="i in practice.star" v-bind:key="i"
                                                                                        class="crown-active-img">
                                                                                </div>
                                                                                <div class="report-item-temp-number">
                                                                                    {{practice.attemp ? practice.attemp.length :
                                                                                    0}} {{$t('attempt')}} {{practice.attemp &&
                                                                                    practice.attemp.length > 1? 's': ''}}
                                                                                </div>
                                                                            </div>
                                                                            <div class="icon-expand-right">
                                                                                <img src="/themes/ito/images/icons/expand_right.svg">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="report-item-body" v-if="practice.attemp">
                                                                        <template>
                                                                            <div v-for="(attemp, a) in practice.attemp" v-bind:key="a">
                                                                                <div class="attemp-list">
                                                                                <span>
                                                                                    {{$t('attempt')}} {{a + 1}} <img
                                                                                        src="/themes/ito/images/icon-crown.svg"
                                                                                        v-for="i in attemp.crown" v-bind:key="i"
                                                                                        class="crown-active-img">
                                                                                </span>
                                                                                    <div class="attemp-status">
                                                                                        <b>{{attemp.correct}}</b>/{{attemp.total}}
                                                                                        {{$t('corrects')}}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="chart-wrapper">
                                                <div class="chart-content">
                                                    <canvas id="radar_chart" height="150" width="150"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div @click="resetEdit" v-show="showTest" class="test"></div> -->
            </template>
            <div class="modal" id="popupLessonUpgradeAccount" tabindex="-1" role="dialog" aria-labelledby="popupUpgradeAccount">
                <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
                    <div class="modal-content box-shadow-main" style="padding: 20px 10px 30px;">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <h3 class="popup-title mb-20">{{ $t('popup_upgrade_acc_title') }}</h3>
                        <p class="txt-popup" >{{ $t('popup_upgrade_acc_content') }}</p>
                        <router-link :to="{ path: '/upgrade-account' }">
                            <div class="ito-btn-small active mt-3" style="width: 160px; margin: auto"
                            @click="handleLinkClick">{{ $t('upgrade_account') }}
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
      <div class="modal lesson-modal fade" id="external-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="extension-modal" aria-hidden="true" >
        <div class="modal-dialog modal-dialog-centered modal-95">
          <div class="modal-content p-0 overflow-hidden">
            <div class="modal-header">
              <h5 class="modal-title flex-fill">{{$t(units.external_name)}}</h5>
              <button type="button" class="close-lesson-modal" data-bs-dismiss="modal"><span>+</span></button>
            </div>
            <div class="modal-body p-0 d-flex w-100" style="position: relative">
                <iframe :src="units.external_link"
                        frameborder="0" allowfullscreen width="100%" height="100%" style="overflow: scroll;"></iframe>
              <div style="position: absolute; right: 0px; bottom: 0px; width: 20%; height: 10%"></div>
            </div>
          </div>
        </div>

      </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from "axios";
    import {mapGetters} from 'vuex';
    import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
    
    import {pushQueries, toPercent} from '../../utils/utils'
    import {
        getListUnit,
        getListLesson,
        getReportUnit,
        getDiscussions,
        sendDiscuss,
        deleteComment,
        editComment,
        getEbook,
    } from "../../models/dashboard";

    export default {
        name: "UnitList",
        title: 'Unit',
        // props: [
        //     'user_info'
        // ],
        data() {
            return this.initState();
        },
        created() {
            this.fetch();
        },
        mounted() {

            // this.popupItem = this.$el
        },
        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            })
        },
        watch: {
            'tab'(item) {
                if (item == 'report') {
                    this.getListReports();
                }else if (item == 'discuss') {
                    this.getListDiscuss();

                }
            }
        },
        methods: {
            openExternal(){
                $("#external-modal").modal("show")
            },
            handleGACustomEvent(element, unit_id) {
                var params = {
                    'w_user_id': this.user_info.user_id,
                    'unit_id': unit_id
                }
                params[element] = this.user_info.user_id + '|' + unit_id
                gtag('event', element, params)
            },
            handleFocusOut(){
                this.editItem = -10
            },  
            handleLinkClick() {
                $('#popupLessonUpgradeAccount').modal('hide');
            },
            rebuildEbookPage(ebook){
                let step1 = ebook.replace('[','');
                let step2 = step1.replace(']','');
                let step3 = step2.replace(',', ' - ');
                return step3;
            },
            resetDiscuss(){
                this.commentType = 'NORMAL';
                this.content = '';
                this.currId = '';
                this.currContent = '';
            },
            upgradeAccountUnitTest(package_name) {
                let text = this.$t('lock_unit_upgrade_package_desc')

                this.message = text.replace('%s', '<b>' + package_name + '</b>');
                $('#popupLessonUpgradeAccount').modal('show');
            },
            showReply(dc) {
                if (dc.show_reply == 1) {
                    Vue.set(dc, 'show_reply', 0);

                } else {
                    Vue.set(dc, 'show_reply', 1);
                }
            },
            initState() {
                return {
                    count: false,
                    showTest: false,
                    units: [],
                    subject: {},
                    isLoading: false,
                    tab: 'overview',
                    type: 1,
                    subject_id: this.$route.params.subject_id,
                    reports: [],
                    currentItem: -10,
                    currentAttemp: -10,
                    lesson_complete: 0,
                    lesson_incomplete: 0,
                    content: '',
                    discuss: [],
                    editItem: -10,
                    // commenter:[],
                    total_comment: 0,
                    comment_select: 0,
                    comment_select_commenter:0,
                    curDc: '',
                    currId: '',
                    curUserReply: '',
                    currContent: '',
                    inputType: '',
                    curCommenter:[],
                    isDetail: true,
                    commentType: 'NORMAL',
                    ebook_link: '',
                    showText: false,
                    message: ''
                };
            },
            changeDetail(){
                this.isDetail = !this.isDetail;
            },
            resetState() {
                Object.assign(this.$data, this.initState());
            },

            resetSearching() {
                this.resetState();

                this.fetch();
            },
            showEdit: function (newItem) {
                if (newItem === this.editItem) {
                    this.editItem = -10
                } else {
                    this.showTest = true
                    this.editItem = newItem
                }
            },
            showEditCommenter: function (newItem) {
                if (newItem === this.editItem) {
                    this.editItem = -10
                } else {
                    this.editItem = newItem
                }
            },
            resetEdit() {
                this.showTest = false
                this.editItem = -10;
            },
            resetEditCommenter() {
                this.editItem = -10;
            },
            fetch(page = 1) {
                this.getListUnits()
            },
            async getListUnits() {
                const that = this;
                that.$store.commit("setLoading", true);
                const params = this.$route.params;
                await axios.all([
                    getListLesson(params),
                    getEbook(params)
                ]).then(axios.spread((list_unit_response, ebook) => {
                    that.$store.commit("setLoading", false);
                    if (list_unit_response.data.code != 0) {
                        return;
                    }
                    if (ebook.data.code == 0){
                        that.ebook_link = ebook.data.results.item.content || '';
                    }
                    that.units = list_unit_response.data.results.units || [];
                    that.subject = list_unit_response.data.results.subject || {};

                    if( that.units.desc.length > 299){
                        that.showText = true;
                    }

                    console.log('units: ', that.units);
                    console.log('ebook: ',  that.ebook_link );

                    window.boChatbot?.setContext('unit', that.units.title)
                    window.boChatbot?.deleteContext('lesson')
                    window.boChatbot?.deleteContext('module')
                }));
            },
            async getListReports() {
                const that = this;
                that.$store.commit("setLoading", true);
                const params = {
                    'subject_id': that.subject_id,
                    'grade': localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade,
                    'unit_id': that.units.id
                }
                await axios.all([
                    getReportUnit(params),
                ]).then(axios.spread((list_report_response) => {
                    that.$store.commit("setLoading", false);
                    if (list_report_response.data.code != 0) {
                        return;
                    }
                    that.reports = list_report_response.data.results.units || [];
                    // that.lesson_complete = that.reports.process/that.reports.total * 100;
                    that.lesson_complete = that.reports.process / that.reports.total * 100;
                    that.lesson_incomplete = (that.reports.total - that.reports.process) / that.reports.total * 100;
                    this.$nextTick(function () {
                        new Chart(document.getElementById("radar_chart").getContext("2d"), that.getChartJs(that.lesson_incomplete.toFixed(2), that.lesson_complete.toFixed(2)));
                    })
                }));
            },
            calcPercent(process, total) {
                return toPercent(process, total);
            },
            mathRound(number) {
                return Math.round(number)
            },
            changeType(layout) {
                this.type = layout;
                if (layout == 2) {
                    this.handleGACustomEvent('IP2_W_2003', this.units.id)
                }
            },
            changeTab(tab) {
                this.tab = tab;
                var event = '';
                if (tab == 'discuss') {
                    event = 'IP2_W_2001';
                } else if (tab == 'report') {
                    event = 'IP2_W_2002';
                }
                this.handleGACustomEvent(event, this.units.id)
            },
            itemTrigger: function (newItem) {
                this.currentAttemp = -10;
                if (newItem === this.currentItem) {
                    this.currentItem = -10
                } else {
                    this.currentItem = newItem
                }
            },
            attempTrigger: function (newItem) {
                if (newItem === this.currentAttemp) {
                    this.currentAttemp = -10
                } else {
                    this.currentAttemp = newItem
                }
            },
            getChartJs(data1, data2) {
                let labels = []
                let text = ""
                if(localStorage.getItem('lang') == "vi"){
                    labels = ['Chưa xong', 'Hoàn thành']
                    text = "Tiến trình bài học"
                }else{
                    labels = ['Incomplete', 'Complete']
                    text = 'Lesson progress'
                }
                
                return {
                    type: 'doughnut',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: "Chart",
                            fill: true,
                            data: [data1, data2],
                            pointBorderWidth: 10,
                            backgroundColor: ['#fd9b17', '#10a9ff'],
                           
                        }]
                    },
                    options: {
                        responsive: true,
                        // legend: false,
                        cutoutPercentage: 20,
                        legend: {
                            position: 'bottom',
                            labels:{
                                usePointStyle:true,
                                boxWidth:20,
                                padding:40
                            }
                        },
                        title: {
                            display: true,
                            text: text,
                            fontColor:"#000000",
                            fontSize:14
                        },
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                                }
                            }
                        },
                        plugins: {
                            datalabels: {
                                formatter: (value, ctx) => {
                                    const datapoints = ctx.chart.data.datasets[0].data
                                    const total = datapoints.reduce((total, datapoint) => total + datapoint, 0)
                                    const percentage = value / total * 100
                                    return percentage.toFixed(2) + "%";
                                },
                                color: '#000',
                            }
                        }
                    }
                }
            },
            async getListDiscuss() {

                const that = this;
                that.$store.commit("setLoading", true);
                const params = {
                    'subject': that.subject_id,
                    'grade': localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade,
                    'unit_id': that.units.id
                }

                await axios.all([
                    getDiscussions(params),
                ]).then(axios.spread((list_discuss_response) => {
                    that.$store.commit("setLoading", false);
                    if (list_discuss_response.data.code != 0) {
                        return;
                    }
                    that.discuss = list_discuss_response.data.results.discuss || [];
                    that.total_comment = list_discuss_response.data.results.total_comment;

                    that.content = '';

                    that.$nextTick(function() {
                        var initNanoScroller = function() {
                            if ($('.nano').length > 0) {
                                $(".nano").nanoScroller();
                            }
                        }
                        initNanoScroller();
                    })                        
                }));
            },

            sendComment() {
                const that = this;

                if(that.content == ''){

                    return false;
                }
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('subject', that.subject_id);
                formData.append('grade', localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade);
                formData.append('unit_id', that.units.id);
                formData.append('content', that.content);
                sendDiscuss(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.discuss = response.data.results.discuss || [];
                    that.total_comment = response.data.results.total_comment;

                    that.content = '';
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },

            replyComment_commenter(dc) {
                const that = this;
                if(dc.reply_content == ''){

                    return false;
                }
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('subject', that.subject_id);
                formData.append('grade', localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade);
                formData.append('unit_id', that.units.id);
                formData.append('content', dc.reply_content);
                formData.append('discuss_id', dc.id);
                sendDiscuss(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    let resData = response.data.results.discuss || [];
                    let curDc = resData.filter(e => e.id == dc.id);
                    let countCommentReply = curDc[0].commenter.length;
                    dc.commenter.push(curDc[0].commenter[countCommentReply - 1]);
                    that.total_comment = response.data.results.total_comment;
                    dc.reply_content = '';
                    that.currContent = '';
                    that.discuss = response.data.results.discuss || [];
                    that.content = '';
                    that.commentType = "NORMAL";
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            replyComment() {

                const that = this;
                if(that.currContent == ''){

                    return false;
                }
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('subject', that.subject_id);
                formData.append('grade', localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade);
                formData.append('unit_id', that.units.id);
                formData.append('content', that.currContent);
                formData.append('discuss_id', that.curDc.id);
                sendDiscuss(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }

                    let resData = response.data.results.discuss || [];
                    let curDc = resData.filter(e => e.id == that.curDc.id);
                    let countCommentReply = curDc[0].commenter.length;
                    that.curDc.commenter = [];
                    that.curDc.commenter.push(curDc[0].commenter[countCommentReply - 1]);
                    that.total_comment = response.data.results.total_comment;
                    that.discuss = response.data.results.discuss || [];
                    that.content = '';
                    that.commentType = "NORMAL";
                    that.currContent = '';
                    // $('#inputComment').modal('hide');
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            deleteConfirm(id) {
                this.comment_select = id;
                $('#deleteConfirm').modal('show');
            },
            deleteConfirmCommenter(commenter) {
                this.curCommenter = commenter;
                this.comment_select =commenter.id;
                $('#deleteConfirmCommenter').modal('show');
            },
            deleteComment(dc) {
                const that = this;
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('id', that.comment_select);
                deleteComment(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.discuss = response.data.results.discuss || [];
                    that.total_comment = response.data.results.total_comment;
                    that.content = '';
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            deleteCommentCommenter() {
                const that = this;
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('id', that.comment_select);
                deleteComment(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.discuss = response.data.results.discuss || [];
                    that.total_comment = response.data.results.total_comment;
                    that.content = '';
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            editCommentConfirm(id, content) {
                const that = this;
                that.currId = id;
                that.curUserReply = '';
                that.currContent = content;
                that.inputType = "EDIT";
                that.commentType = "EDIT";
                // $('#editConfirm').modal('show');
            },
            editCommentConfirmCommenter(commenter) {
                const that = this;
                this.curCommenter = commenter;
                that.currId =commenter.id;
                that.curUserReply = '';
                that.currContent =commenter.content;
                that.inputType = "EDIT";
                that.commentType = "EDIT";
                // $('#editConfirmCommenter').modal('show');
            },
            replyCommentConfirm(dc) {
                const that = this;
                that.curDc = dc;
                that.currContent = '';
                that.curUserReply = dc.fullname;
                that.inputType = "REPLY";
                that.commentType = "REPLY";
                // $('#inputComment').modal('show');

                initNanoScroller();
            },
            editComment() {
                const that = this;
                if (that.currContent == '') {

                    return false;
                }
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('id', that.currId);
                formData.append('content', that.currContent);
                formData.append('unit_id', that.units.id);
                editComment(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.discuss = response.data.results.discuss || [];
                    that.total_comment = response.data.results.total_comment;
                    that.content = '';
                    that.commentType = "NORMAL";
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
                // $('#editConfirm').modal('hide');
            },
            editCommentCommenter(dc) {
                const that = this;
                if (that.currContent == '') {
                    return false;
                }
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('id', that.currId);
                formData.append('content', that.currContent);
                formData.append('unit_id', that.units.id);
                editComment(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.curCommenter.content = that.currContent;
                    that.total_comment = response.data.results.total_comment;
                    that.content = '';
                    that.commentType = "NORMAL";
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
                // $('#editConfirmCommenter').modal('hide');
            },
            timeConverter(UNIX_timestamp) {
                var a = new Date(UNIX_timestamp * 1000);
                var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
                var year = a.getFullYear();
                var month = months[a.getMonth()];
                var date = a.getDate();
                var hour = a.getHours();
                var min = a.getMinutes();
                var sec = a.getSeconds();
                var time = date + '/' + month + '/' + year + ' - ' + hour + ':' + min + ':' + sec;
                return time;
            }
        }
    }
</script>

<style scoped>
.modal-header{
  border-bottom: 1px solid #dee2e6;
}

.btn-close {
    width: 13px;
    height: 13px;
    position: absolute;
    background: url("../../../public/themes/ito/images/close.svg") no-repeat;
    background-size: 100%;
    top: 13px;
    right: 13px;
    cursor: pointer;
    border: none;
}

.ito-btn-small {
    height: 35px;
    width: 108px;
    background: #B2B2B2;
    -webkit-border-radius: 100px;
    -moz-border-radius: 100px;
    border-radius: 100px;
    /*box-shadow: 4px 4px rgba(0, 0, 0, 0.07);*/
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    color: #fff;
    text-align: center;
    line-height: 33px;
    cursor: pointer;
    font-size: 1rem;
}

.ito-btn-small.active {
    background: #00A3FF;
}

.lesson-modal .modal-content {
  padding: 0 !important;
  overflow: hidden;
  border-radius: 16px;
}

.lesson-modal .modal-header {
  display: flex;
  height: 52px;
  padding: 0;
}

.lesson-modal .modal-header .modal-title {
  text-align: left;
  font-size: 20px;
  font-weight: 700;
  color: #1B1B1B;
  line-height: 24px;
  padding-left: 1rem;
}

.lesson-modal .modal-header .close-lesson-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  width: 52px;
  height: 52px;
  background: #F04821;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  border: 0;
}
.lesson-modal .modal-header .close-lesson-modal:hover{
  background: #f04721bc;

}

.close-lesson-modal span {
  display: flex;
  width: 26px;
  height: 26px;
  background: #ffffff;
  color: #f04821;
  font-size: 26px;
  line-height: 26px;
  font-weight: bold;
  border-radius: 100%;
  transform: rotate(45deg);
  align-items: center;
  justify-content: center;
}
.modal-95 {
  width: 95vw;
  max-width: none;
  height: 100%;
  margin: 0 auto;
}

.modal-95 .modal-content {
  height: 95%;
  border: 0;
  border-radius: 8px;
}

.modal-content {
  border-radius: 16px;
  padding: 20px 50px;
  position: relative;
}
    @-webkit-keyframes cssProgressActive {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 35px 35px;
        }
    }

    @keyframes cssProgressActive {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 35px 35px;
        }
    }

    @-webkit-keyframes cssProgressActiveRight {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: -35px -35px;
        }
    }

    @keyframes cssProgressActiveRight {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: -35px -35px;
        }
    }

    .card-comments.card>.card-body>.card-bottom {
        bottom: -30px !important;
    }

    .progress {
        opacity: 1;
    }

    .progress-load {
        background-color: #FFC700 !important;
        -webkit-animation: cssProgressActive 3s linear infinite;
        animation: cssProgressActive 3s linear infinite;
        transition: none 0s ease 0s;
    }

    #unit-detail .lesson-item-bottom > .progress > .progress-load {
        background-image: linear-gradient(
                -45deg, rgba(255, 255, 255, 0.125) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.125) 50%, rgba(255, 255, 255, 0.125) 75%, transparent 75%, transparent);
        background-size: 15px 15px;
    }

    #unit-detail .lesson-item-bottom > .progress > span {
        padding-left: 20px;
        padding-top: 0px;
    }

    #unit-detail .lesson-item-bottom {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #AAABB7;
        align-items: center;
    }
    #unit-detail .lesson-item-bottom.complete{
        background-color: #98C93C;
        color: #fff;
    }

    .ito-tabs a.active {
        color: #fff;
        background: #5AC9F7;
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
    }

    .lesson-item-body .title {
        text-align: center;
    }

    .lesson-item-lv.report-items {
        padding: 4px 20px;
        margin-bottom: 0;
    }

    .report-items .c100 > span {
        font-size: 11px;
    }

    .lesson-report-container {
        /*background: #F6F6F6;*/
        /*box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07);*/
        border-radius: 8px;
        margin-bottom: 8px;
    }

    .report-child-items {
        padding: 12px 20px;
    }

    .report-attemps {
        background: #FFFFFF;
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        margin-bottom: 8px;
        padding: 12px 20px;
    }

    .chart-wrapper {
        background: #FFFFFF;
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        padding: 8px;
    }

    .icon-expand-right {
        width: 24px;
        height: 24px;
        margin-left: 8px;
    }

    .active .icon-expand-right img {
        transform: rotate(90deg);
    }

    .report-item-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
    }

    .report-item-head-right {
        display: flex;
        align-items: center;
        text-align: right;
    }

    .report-item-title {
        font-size: 13px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        color: #1E263C;
    }

    .report-item-temp-number {
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 0.02em;
        color: rgba(30, 38, 60, 0.5);
    }

    .report-item-childs, .report-item-body {
        display: none;
        -webkit-animation: fadeout 1s; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: fadeout 1s; /* Firefox < 16 */
        -ms-animation: fadeout 1s; /* Internet Explorer */
        -o-animation: fadeout 1s; /* Opera < 12.1 */
        animation: fadeout 1s;
    }

    .active + .report-item-childs, .active + .report-item-body {
        display: block;
        -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: fadein 1s; /* Firefox < 16 */
        -ms-animation: fadein 1s; /* Internet Explorer */
        -o-animation: fadein 1s; /* Opera < 12.1 */
        animation: fadein 1s;
    }

    .report-item-body {
        border: 1px solid rgba(0, 0, 0, 0.2);
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        margin-top: 8px;
        padding: 0;
        overflow: hidden;
    }

    .attemp-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 8px;
        font-size: 13px;
        line-height: 16px;
    }

    .attemp-list:not(last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }

    .attemp-list .crown-active-img {
        width: 14px;
        margin-top: -5px;
    }

    .report-item-head-right .crown-active-img {
        width: 15px;
    }

    .ebook-link {
        margin-top: 12px;
        font-size: 13px;
        display: flex;
        align-items: center;
        background: #00A3FF;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;
        border-radius: 8px;
        padding: 8px 12px 8px 12px;
        /* width: 117px; */
        width: fit-content;
        height: 32px;
        color: #FFFFFF;
    }
    .card-comments .card-content {
        padding: 25px 22px;
        overflow-x: auto;
        max-height: 550px;
    }
    .comment-item {
        background: #FFFFFF;
        border: 2px solid rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        border-radius: 8px;
        padding: 15px 19px;
        margin-bottom: 10px;
        display: flex;
        margin-top: 15px;
    }

    .comment-item .comment-item-avatar {
        width: 60px;
    }
    .comment-item .comment-item-avatar img {
        filter: drop-shadow(4px 4px 0px rgba(0, 0, 0, 0.07));
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    .comment-item .comment-item-info {
        flex: 1;
        padding-left: 20px;
    }

    .comment-item .comment-item-info .header {
        display: flex;
    }

    .comment-item .comment-item-info .header .title {
        flex: 1;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.02em;
        color: #070A28;
    }

    .comment-item .comment-item-info .header .time {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.02em;
        color: #070A28;
        width: 200px;
        text-align: right;
        display: flex;
        justify-content: end;
        height: 24px;
        align-items: center;
    }

    .comment-item .comment-item-info .desc {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.02em;
        color: #070A28;
        margin-top: 8px;
    }
    .desc-1 {
        /* font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.02em; */
        color: #070A28;
        /* margin-top: 8px; */
        font-size: 14px;
    }

    .comment-item:last-child {
        margin-bottom: 0;
    }
    .replies-img {
        width: 20px;
        height: 40px;
        transform: rotate(45deg);
    }

    .replies-img-1 {
        width: 20px;
        height: 40px;
        /* transform: rotate(45deg); */
        position: absolute;
        z-index: 999;
        left: -45px;
        cursor: pointer;
    }

    .edit-comment {
        cursor: pointer;
        position: relative;
    }

    .box-edit {
        position: absolute;
        /* height: 104px; */
        width: 247px;
        border-radius: 8px;
        border: 2px solid rgba(229, 229, 229, 1);
        box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.07);
        top: 25px;
        right: -21px;
        background: #ffffff;
        display: none;
        overflow: hidden;
        z-index: 99999 !important;
    }

    .edit-cmt.active .box-edit {
        display: block;
        z-index: 99999 !important;
    }

    .edit-li {
        width: 100%;
        height: 50%;
        text-align: center;
        color: #fd9301;
        font-size: 16px;
        line-height: 3;
        cursor: pointer;
        background: #ffffff;
        border: antiquewhite

    }

    .delete-li {
        width: 100%;
        height: 50%;
        text-align: center;
        color: #000000;
        font-size: 15px;
        line-height: 3;
        cursor: pointer;
        background: #ffffff;
        border: antiquewhite

    }

    .reply-li {
        width: 100%;
        height: 50%;
        text-align: center;
        color: #000000;
        font-size: 15px;
        line-height: 3;
        cursor: pointer;
        background: #ffffff;
        border: antiquewhite

    }
    .reply-li:hover {
        background: #cdd0d7;
    }
    .edit-li:hover {
        background: #cdd0d7;
    }

    .delete-li:hover {
        background: #cdd0d7;
    }
    .button-replies {
        color: #bfa6a6;
        bottom: 0%;
        width: 96%;
        text-align: left;
        background: #FFFFFF;
        border: 1.5px solid #E9E9E9;
        box-sizing: border-box;
        border-radius: 8px;
        height: 32px;
    }
    .card-content-commenter {
        margin-left: 52px;
    }
    .modal-content-edit {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .2);
        border-radius: 0.3rem;
        outline: 0;
        border-radius: 20px;
    }
    .form {
        background: #FFFFFF;
        border: 2px solid #E4E4E4;
        box-sizing: border-box;
        border-radius: 8px;
        padding: 4px 6px;
        display: flex;
    }

    .form > input[type=text] {
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        align-items: center;
        flex: 1;
        border: none;

    }

    .form > button {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #40C0F6;
        box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 14px;
        text-align: center;
        letter-spacing: 0.02em;
        color: #FFFFFF;
        padding: 7px 15px;
        width: 70px;
    }

    #inputComment .modal-content {
        padding: 0;
        border-radius: 30px
    }
    .commenter{
        margin-bottom: 15px;
    }
    .reply-to {
        color: #000000;
        margin-block: 8px;
        font-weight: bold;
        font-size: 15px;
    }
    .box-shadow-main {
        /*box-shadow: 4px 4px rgba(0, 0, 0, 0.07);*/
        border-radius: 8px;
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    }
    .modal-content {
        padding: 20px 50px 30px;
        position: relative;
    }
    .close-popup {
        width: 18px;
        height: 18px;
        position: absolute;
        /*background: url(themes/images/close.svg) no-repeat;*/
        background-size: 100%;
        top: 13px;
        right: 13px;
        cursor: pointer;
    }
    .popup-title {
        text-align: center;
        color: #070A28;
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        margin: auto;
    }
    .lisa-btn-small {
        display: block;
        height: 35px;
        width: 95px;
        background: #B2B2B2;
        border-radius: 8px;
        /*box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);*/
        color: #fff;
        text-align: center;
        line-height: 33px;
        font-size: 14px;
        cursor: pointer;
        text-decoration: none;
    }

    .lisa-btn-small.active {
        background: #00A3FF;
    }
    .txt-pop{
        font-size: 15px;
        color: #000;
        text-align: center;
        line-height: 20px;
    }
    .card-content::-webkit-scrollbar-track {
        /*-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/
        /*border-radius: 10px;*/
        background-color: #ffffff;
    }
    .card-content::-webkit-scrollbar {
        width: 8px;
        background-color: #BDBDBD;
    }
    .card-content::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #BDBDBD;
    }
    .tools {
        width: 300px;
        text-align: right;
    }
    .ito-tabs {
        margin-top: 0;
        font-size: 14px;
        padding: 0px;
        list-style: none;
        background: rgba(255, 255, 255, 0.56);
        box-shadow: 4px 4px 0px rgba(0,0,0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
        display: inline-block;
        border-radius: 8px;
        position: relative;
    }
    .ito-tabs a {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.5);
        padding: 0px 15px;
        display: inline-block;
        position: relative;
        z-index: 1;
        transition-duration: 0.6s;
        height: 37px;
        line-height: 38px;
        font-size: 14px;
        font-weight: 600;
    }
    .ito-tabs a.active{
        color: #fff;
        background: #5AC9F7;
        box-shadow: 4px 4px 0px rgb(0 0 0 / 5%);
        border-radius: 8px;
    }

    .card-bottom-commenter,
    .card-content-commenter,
    .comment-item{
        position: relative;
    }
    .card-content-commenter::before{
        content: '';
        display: block;
        position: absolute;
        left: -15px;
        width: 1px;
        height: 100%;
        background: rgba(51, 122, 183, 0.75);
        top: 0;
    }
    .comment-item-reply::after{
        content: '';
        display: block;
        position: absolute;
        left: -23px;
        width: 13px;
        height: 13px;
        border-radius: 100%;
        margin-top: -6px;
        top: 50%;
        background: rgba(51, 122, 183, 1);
    }
    .comment-replies:first-child .comment-item-reply::before{
        content: '';
        display: block;
        position: absolute;
        left: -17px;
        width: 1px;
        height: 50%;
        background: #fff;
        top: 0px;
    }
    
    .card-bottom-commenter::after{
        content: '';
        display: block;
        position: absolute;
        left: -21px;
        width: 13px;
        height: 13px;
        margin-top: -6px;
        border-radius: 100%;
        top: 50%;
        background: rgba(51, 122, 183, 1);
    }    
    .card-bottom-commenter::before{
        content: '';
        display: block;
        position: absolute;
        left: -15px;
        width: 1px;
        height: 50%;
        background: #fff;
        bottom: 0;
    }
    .title-rep{
        color: #070A28;
        font-size: 12px;
        margin-bottom: 10px;
    }
    .reset-commenter{
        font-size: 12px;
        color: #E84343;
        font-weight: 700;
        text-decoration: underline;
        margin-left: 15px;
        cursor: pointer;
    }

    /* .container{
        width: 940px;
        padding: 0;
    } */
    .view-more{
        font-style: normal;
        font-weight: 700;
        font-size: 13px;
        line-height: 16px;
        text-decoration-line: underline;
        color: #11A9FF;
        /* margin: 0; */
        margin-top: 5px;
    }
    .lock-unit .lock-image{
        right: 10px;
        left: auto;
        top: 5px;
        width: 28px;
    }
    .lock-unit:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
    }
    .lock-unit .lock-image {
        position: absolute;
        z-index: 10;
        top: 25%;
        left: 0;
        right: 0;
        margin: auto;
        width: 48px;
        height: 48px;
    }
    .test{
        background-color: red;
        opacity: 0.3;
        position: absolute;
        z-index: 11 !important;
        top: 0;
        bottom: 0;
        width: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    .test-1{
        background-color:#fff;
        opacity: 0;
        position: absolute;
        z-index: 11 !important;
        top: -200px;
        bottom: 0;
        width: 0;
        left: -500px;
        width: 100vw;
        height: 100vh;
    }
    .card-comments{
        z-index: 13 !important;
    }
    .lesson-item{
        box-shadow: none !important;
        border: 1px solid #CCD2E3;
    }
</style>